// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "portal-260625-12/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};